const odAlreadySelected = (destination, origin) => Boolean(origin && origin.length > 0 && destination && destination.length > 0);

/**
 *  Gets called by the react-calendar component and
 *  is used to add a class to each visible date tile.
 *  We use it to show the selected dates and everything in between
 * */
const setTileClassName = ({ outboundDate, inboundDate, date, view }) => {
  if (view !== 'month') {
    return null;
  }

  if (!outboundDate || !inboundDate) {
    return null;
  }

  /**
   *  We parse date to number for easy date comparison. We could use moment
   *  here but because we are running this comparison on a lot of cells,
   *  it becomes slow and heavy so we opt for the light weight option
   * */
  switch (true) {
    // if it's start date
    case Number(date) === Number(outboundDate):
      return 'react-calendar__tile--active';
    // if it's end date
    case Number(date) === Number(inboundDate):
      return 'react-calendar__tile--active';
    // if it's between start and end dates
    case Number(date) > Number(outboundDate) && Number(date) < Number(inboundDate):
      return 'react-calendar__tile-away-dates'; // may want to change this class to something with a different colour so only the start and end dates have the solid blue background
    default:
      return null;
  }
};

export { odAlreadySelected, setTileClassName };
